import type { FormChatStep } from "../repositories/formChat.repository";

/**
 * The API tags the bath status question with the "review" step, and the chat
 * shell hides chips and the composer on "review". While a field is still
 * being asked, the step is not the review yet.
 */
export const resolveRitualBathStep = (
  step: FormChatStep,
  activeField: string | null | undefined,
): FormChatStep => (step === "review" && activeField ? "basic-info" : step);
